export const getCurrentLocation = (pathname: string): string => `https://localhost:3000${pathname}`;
